import {ExchangeAccountId} from '../../models/exchange-account';
import {Security} from '../../models/security';
import {formatSecurityKey} from '../../models/security-key';

export interface Position {
    id: number;
    securityId: number;
    security: Security;
    quantity: number;
    openDateTime: string;
    closeDateTime: string;
    averagePrice: number;
    marketCost: number;
    realizedPnl: number;
    openPnl: number;
    totalPnl: number; // Could be not actual, since it's not changed here after MARKET_COST_UPD. Use baseTotalPnL.
    costBasis: number;
    accountId: ExchangeAccountId;
    liquidationPrice: number;

    /**
     * These extra fields are required in order to recalculate related values after marketCost updates.
     */
    baseMarketCost?: number;
    baseTotalPnL?: number;

    /**
     * These fields are for HG project only.
     * They are not calculated, but retrieved from remote API.
     * "Ext" means "external".
     */
    marketCostExt: number;
    openPnlExt: number;
    totalPnlExt: number;

    /**
     * Quantity in baseAsset.
     * Actual for BitMEX only for now.
     */
    baseValue: number;
}

/**
 * [HED-370] It may be not correct to track positions by {@link Position.id} only,
 * since it can be the same for the same security, but different account.
 * This function creates combined key, which is unique for position.
 */
export const getPositionIdentificationKey = (position: Position): string => [
    position.id,
    formatSecurityKey(position.security),
    position.accountId || ''
].join('_');
